import * as React from 'react';
import {Route, Router, Switch, Redirect} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {HealthDashboard} from "src/components/healthDashboard/HealthDashboard";
import {HEALTH_DASHBOARD_PATH} from "src/common/constants/constants";

const history = createBrowserHistory();

export default function UrlPathRouter() {
    return (
        <div>
            <Router history={history}>
                <div id='routes'>
                    <Switch>
                        <Route exact path={HEALTH_DASHBOARD_PATH} component={HealthDashboard} />
                        <Route path="*">
                            <Redirect to={HEALTH_DASHBOARD_PATH} />
                        </Route>
                    </Switch>
                </div>
            </Router>
        </div>
    );
}
